import { format, isValid, parse } from 'date-fns';
import { useMemo } from 'react';
import { getTodayDate } from '../utilities/index.js';
export function useDateFormat(pattern = 'PPPPp') {
    return useMemo(() => {
        try {
            const date = new Date(-62135618008000);
            const parsedDate = parse(format(date, pattern), pattern, getTodayDate());
            if (!isValid(parsedDate) || format(parsedDate, 'MM-dd-yyyy') !== format(date, 'MM-dd-yyyy')) {
                throw { message: 'Parse error for current date format pattern' };
            }
            return { pattern };
        }
        catch (error) {
            console.error(`Date Format pattern is not valid. ${error?.message}. Applied default format PPPPp of date-fns`);
            return { pattern: 'PPPPp' };
        }
    }, [pattern]);
}
//# sourceMappingURL=useDateFormat.js.map